export default __webpack_public_path__ + "static/media/dept-logo.346d5735.svg";